import React, { useState } from 'react';
import { Button, Form, Select, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

export default function ModalMove({ open, handelClose }) {
    const { t } = useTranslation(['metadata']);
    const [form] = Form.useForm();
    const [loading] = useState(false);
    const onFinish = async (e) => {
        console.log(e);
    };
    const [groupList] = useState(mock);
    return (
        <Modal
            centered
            width={500}
            className="_modal"
            footer={false}
            open={open}
            onCancel={() => {
                form.resetFields();
                handelClose();
            }}
            afterClose={() => {
                form.resetFields();
            }}
        >
            <div>
                <div className="text-1xl text-center">{t('Move')}</div>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        className="my-10"
                        name="moveTo"
                        label={t('Move To')}
                        // rules={[
                        //     {
                        //         required: true,
                        //         message: t('requiredField'),
                        //     },
                        // ]}
                    >
                        <Select
                            size="large"
                            onChange={(e) => {
                                console.log(e);
                            }}
                            placeholder={t('Select Group')}
                            defaultValue={111}
                        >
                            {groupList.map((e) => {
                                return (
                                    <Select key={e.id} value={e.id}>
                                        {e.value}
                                    </Select>
                                );
                            })}
                        </Select>
                    </Form.Item>
                    <div className="flex justify-center items-center space-x-4">
                        <Button
                            type="primary"
                            className="min-w-[150px]"
                            onClick={handelClose}
                            size="large"
                            ghost
                        >
                            {t('Cancel')}
                        </Button>

                        <Button
                            loading={loading}
                            // onClick={handelOk}
                            className="min-w-[150px]"
                            size="large"
                            type="primary"
                            htmlType="submit"
                        >
                            {t('Submit')}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
}

const mock = [
    {
        id: 111,
        value: 'Personal Data',
    },
    {
        id: 112,
        value: 'Sensitive Data',
    },
];
